export enum AppIdentityType {
    AzureAppRegistrationAppId = 1,
    AzureAppRegistrationObjectId = 2,
    PartnerId = 3,
}
